import React from "react";
import Button from "components/CustomButton";
import * as microsoftTeams from "@microsoft/teams-js";

const styles = {
  imageRecorder: {
    maxWidth: "80vw",
    backgroundColor: "#999999",
  },
  recoderButton: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default ({ onChange = () => {} }) => {
  const classes = styles;

  const displayteamsRecorder = () => {
    microsoftTeams.app.initialize().then(() => {
      const imageProps = {
        sources: [microsoftTeams.media.Source.Camera],
        startMode: microsoftTeams.media.CameraStartMode.Photo,
        ink: true,
        textSticker: true,
        enableFilter: true,
      };
      
      const microsoftConstraint = {
        mediaType: microsoftTeams.media.MediaType.Image,
        imageProps: imageProps,
      };

      microsoftTeams.media.selectMedia(microsoftConstraint)
        .then((attachments) => {
          if (attachments && attachments.length > 0) {
            const imageResult = attachments[0];
            imageResult.content.getReader().read()
              .then(({ value }) => {
                if (value) {
                  const blob = new Blob([value], { type: "image/png" });
                  const image_output = new File(
                    [blob],
                    `${new Date().getTime()}.jpg`,
                    {
                      type: "image/png",
                    }
                  );
                  onChange(image_output);
                }
              })
              .catch((error) => {
                console.log("Error reading image content:", error);
              });
          }
        })
        .catch((error) => {
          console.log("Error selecting media:", error);
        });
    });
  };

  return (
    <div style={classes.imageRecorder}>
      <div style={classes.recoderButton}>
        <Button buttonClass={'RecorderDialogButton androidRecordingButton'} onClick={displayteamsRecorder}>Click to capture Image</Button>
      </div>
    </div>
  );
};
